module.exports = function(done, value){
  return {value: value, done: !!done};
};


//////////////////
// WEBPACK FOOTER
// /home/backend/KreditCentr/WebLombard/client/~/core-js/modules/_iter-step.js
// module id = ../../../../core-js/modules/_iter-step.js
// module chunks = 3